import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/home.svg'


const _withScopeId = n => (_pushScopeId("data-v-2333a996"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  src: _imports_0
}
const _hoisted_2 = { class: "mobile-menu__link dropdown-label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_list = _resolveComponent("q-list")!

  return (_openBlock(), _createElementBlock("nav", null, [
    _createVNode(_component_q_list, {
      tag: "ul",
      class: "mobile-menu__list"
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getNavLinks(), (link) => {
          return (_openBlock(), _createElementBlock(_Fragment, {
            key: link.label
          }, [
            (!link.children)
              ? (_openBlock(), _createBlock(_component_q_item, {
                  key: 0,
                  onMouseover: ($event: any) => (_ctx.isHovered = link.label),
                  onMouseout: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isHovered = '')),
                  tag: "li",
                  class: _normalizeClass({ active: _ctx.isLinkActive(link) })
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_router_link, {
                      to: { path: link.path, hash: link.hash },
                      class: "mobile-menu__link",
                      onClick: ($event: any) => (_ctx.handleNavClick($event, link.path, link.hash))
                    }, {
                      default: _withCtx(() => [
                        (link.isHome)
                          ? (_openBlock(), _createElementBlock("img", _hoisted_1))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _createTextVNode(_toDisplayString(link.label), 1)
                            ], 64))
                      ]),
                      _: 2
                    }, 1032, ["to", "onClick"])
                  ]),
                  _: 2
                }, 1032, ["onMouseover", "class"]))
              : (_openBlock(), _createBlock(_component_q_item, {
                  key: 1,
                  tag: "li",
                  class: "dropdown",
                  onMouseover: _cache[1] || (_cache[1] = ($event: any) => (_ctx.dropdownOpen = true)),
                  onMouseleave: _cache[2] || (_cache[2] = ($event: any) => (_ctx.dropdownOpen = false))
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_2, [
                      _createElementVNode("div", {
                        class: _normalizeClass(['service-square', _ctx.getServiceColorClass(link)])
                      }, null, 2),
                      _createTextVNode(" " + _toDisplayString(link.label), 1)
                    ]),
                    _createElementVNode("ul", {
                      class: _normalizeClass(["dropdown-menu", { open: _ctx.dropdownOpen }])
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(link.children, (child) => {
                        return (_openBlock(), _createElementBlock("li", {
                          key: child.label,
                          class: _normalizeClass([
                'dropdown-item',
                { active: _ctx.isLinkActive(child) },
                _ctx.getLinkClass(child.label),
              ])
                        }, [
                          _createVNode(_component_router_link, {
                            to: { path: child.path, hash: child.hash },
                            class: "mobile-menu__link",
                            onClick: ($event: any) => (_ctx.handleNavClick($event, child.path, child.hash))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(child.label), 1)
                            ]),
                            _: 2
                          }, 1032, ["to", "onClick"])
                        ], 2))
                      }), 128))
                    ], 2)
                  ]),
                  _: 2
                }, 1024))
          ], 64))
        }), 128))
      ]),
      _: 1
    })
  ]))
}